"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteCountSource = void 0;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const components_common_forms_1 = require("@hotelplan/components.common.forms");
const fdr_regular_fusion_fdr_autocomplete_context_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-context");
const fdr_regular_basis_fdr_autocomplete_count_context_1 = require("@hotelplan/fdr.regular.basis.fdr-autocomplete-count-context");
function AutocompleteCountSuggestionItem(props) {
    const { item, suggestionIndex } = props;
    const autocompleteCountContext = (0, fdr_regular_basis_fdr_autocomplete_count_context_1.useFdrAutocompleteCountContext)();
    const autocompleteContext = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    (0, react_1.useEffect)(() => {
        const countItem = autocompleteCountContext.items.find(i => {
            return i.id === item.id;
        });
        if (countItem &&
            !lodash_1.default.isEqual({ count: countItem.count, loading: countItem.loading }, item.countState)) {
            autocompleteContext.updateSuggestion(suggestionIndex, Object.assign(Object.assign({}, item), { countState: {
                    count: countItem.count,
                    loading: countItem.loading,
                } }));
        }
        if (!countItem) {
            autocompleteCountContext.putItem({
                id: item.id,
                items: [item],
            });
        }
    }, [autocompleteCountContext === null || autocompleteCountContext === void 0 ? void 0 : autocompleteCountContext.items]);
    return null;
}
function FdrAutocompleteCountSource(props) {
    var _a;
    const { autocompleteItemFilter = (items) => items, travelDestinations, objectId, } = props;
    const idRef = (0, react_1.useRef)(null);
    const [isObjectIdChanged, setIsObjectIdChanged] = (0, react_1.useState)(false);
    const { values: formValues } = (0, components_common_forms_1.useFormContext)();
    const autocompleteContext = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    const autocompleteCountContext = (0, fdr_regular_basis_fdr_autocomplete_count_context_1.useFdrAutocompleteCountContext)();
    (0, react_1.useEffect)(() => {
        if (!objectId)
            return;
        if (idRef.current === null) {
            idRef.current = objectId;
        }
        if (objectId !== idRef.current) {
            setIsObjectIdChanged(true);
        }
        idRef.current = objectId;
    }, [objectId]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = autocompleteContext === null || autocompleteContext === void 0 ? void 0 : autocompleteContext.selectedItems) === null || _a === void 0 ? void 0 : _a.length) {
            const filteredItems = autocompleteItemFilter(autocompleteContext.selectedItems);
            if (filteredItems.length) {
                const countItem = autocompleteCountContext.items.find(item => {
                    return (filteredItems.length === item.items.length &&
                        lodash_1.default.intersection(filteredItems.map(i => i.id), item.items.map(i => i.id)).length === filteredItems.length);
                });
                if (!countItem) {
                    autocompleteCountContext.putItem({
                        id: filteredItems.map(i => i.id).join(';'),
                        items: filteredItems,
                    });
                }
            }
        }
    }, [autocompleteContext.selectedItems, isObjectIdChanged]);
    (0, react_1.useEffect)(() => {
        var _a;
        const destinations = isObjectIdChanged &&
            ((_a = formValues === null || formValues === void 0 ? void 0 : formValues.travelDestination) === null || _a === void 0 ? void 0 : _a.destinations.length) === 1
            ? travelDestinations
            : autocompleteContext.selectedItems;
        const selected = destinations.map(selectedItem => {
            const countItem = autocompleteCountContext.items.find(item => {
                return (item.items.length === 1 &&
                    lodash_1.default.intersection([selectedItem.id], item.items.map(i => i.id)).length === item.items.length);
            });
            if (countItem &&
                !lodash_1.default.isEqual({ count: countItem.count, loading: countItem.loading }, selectedItem.countState)) {
                return Object.assign(Object.assign({}, selectedItem), { countState: {
                        count: countItem.count,
                        loading: countItem.loading,
                    } });
            }
            return selectedItem;
        });
        if (!lodash_1.default.isEqual(selected, autocompleteContext.selectedItems)) {
            autocompleteContext.setSelected(selected);
        }
        if (isObjectIdChanged) {
            setIsObjectIdChanged(false);
        }
    }, [autocompleteCountContext.items, isObjectIdChanged]);
    return (react_1.default.createElement(react_1.default.Fragment, null, ((_a = autocompleteContext === null || autocompleteContext === void 0 ? void 0 : autocompleteContext.suggestions) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
        autocompleteItemFilter(autocompleteContext.suggestions).map(item => {
            const suggestionIndex = autocompleteContext.suggestions.findIndex(suggestion => suggestion.id == item.id);
            return (react_1.default.createElement(AutocompleteCountSuggestionItem, { key: `${item.id}-${suggestionIndex}`, suggestionIndex: suggestionIndex, item: item }));
        })));
}
exports.FdrAutocompleteCountSource = FdrAutocompleteCountSource;
//# sourceMappingURL=index.js.map